import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';

export const SearchInputContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const StyledTextField = styled(TextField)`
    &.search-input {
        max-width: 300px;
    }

    &.search-options:hover {
        opacity: 0.8;
    }
    & .MuiInputBase-root {
        background-color: white;
        border-radius: 4px;
        padding-right: 8px;
        border-width: 1px;
        font-size: 14px;
    }

    & .MuiSelect-select {
        font-size: 14px;
        padding: 10px;
        background-color: white;
        transition: background-color 0.2s;
    }

    & .MuiSelect-select:focus {
        background-color: white;
    }

    & .MuiFormLabel-root.Mui-focused {
        color: #00a5ac;
    }

    & .MuiInput-underline:before {
        border-bottom: none;
    }

    & .MuiInput-underline:hover:not(.Mui-disabled):before {
        border-bottom: none;
    }

    & .MuiInput-underline:after {
        border-bottom: none;
    }

    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: rgb(124, 124, 124);
        border-width: 1px;
    }

    & .MuiOutlinedInput-notchedOutline {
        border-color: rgb(193, 196, 214);
        opacity: 0.8;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
        border-color: rgb(193, 196, 214);
    }

    & .Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: rgb(193, 196, 214);
    }

    & input {
        padding: 10px;
    }
`;

export const SearchOptionsWrapper = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
`;
